import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import { useFormikContext } from "formik";
import { useMemo } from "react";
import { CreateFormData } from "../../../types/forms";
import { TYPE_FORMS } from "../../../utils/constants";
import { Table } from "../../Table";
import { useStyles } from "./styles";

export function Review() {
  const formik = useFormikContext<CreateFormData>();
  const styles = useStyles();

  const valueType = useMemo(() => {
    return TYPE_FORMS.find(({ value }) => value === formik.values.typeForm);
  }, [formik.values.typeForm]);

  const fontColor = useMemo(() => {
    return { backgroundColor: formik.values.fontColorForm };
  }, [formik.values.fontColorForm]);

  const backgroundColor = useMemo(() => {
    return { backgroundColor: formik.values.bgColorForm };
  }, [formik.values.bgColorForm]);

  const lookupInputType = useMemo(() => {
    return {
      text: "Resposta curta",
      textarea: "Parágrafo",
      select: "Lista suspena",
      date: "Data",
      yesOrNo: "Sim ou Não",
      checkbox: "Caixa de seleção",
    };
  }, []);

  const lookupKey = useMemo(() => {
    return {
      profissao: "Profissão",
      documento: "Documento",
      sexo: "Gênero",
      nome: "Nome",
      apelido: "Apelido",
      data_nascimento: "Data Nascimento",
      telefone1: "Telefone 1",
      telefone2: "Telefone 2",
      telefone3: "Telefone 3",
      telefone4: "Telefone 4",
      celular1: "Celular 1",
      celular2: "Celular 2",
      celular3: "Celular 3",
      celular4: "Celular 4",
      email1: "Email 1",
      email2: "Email 2",
      email3: "Email 3",
      email4: "Email 4",
      endereco: "Endereço",
      cep: "CEP",
      numero: "Número",
      bairro: "Bairro",
      cidade: "Cidade",
      uf: "UF",
      complemento: "Complemento",
      blacklist_email: "Receber email ?",
      blacklist_sms: "Receber SMS ?",
      blacklist_whats: "Receber whatsapp ?",
    };
  }, []);

  return (
    <>
      <Typography color="primary" marginBottom={2}>
        Resumo
      </Typography>
      <Typography marginBottom={1} marginTop={1} marginRight={1}>
        Tipo do formulário: {valueType?.label}
      </Typography>
      <Typography marginBottom={1} marginTop={1} marginRight={1}>
        Nome: {formik.values.nameForm}
      </Typography>

      <Typography
        display="flex"
        alignItems="center"
        marginBottom={1}
        marginTop={1}
        marginRight={1}
      >
        Cor da fundo:
        <div style={backgroundColor} className={styles.viewColor} />
        {formik.values.bgColorForm}
      </Typography>

      <Typography
        display="flex"
        alignItems="center"
        marginBottom={1}
        marginTop={1}
        marginRight={1}
      >
        Cor da fonte: <div style={fontColor} className={styles.viewColor} />
        {formik.values.fontColorForm}
      </Typography>
      <Typography marginBottom={1} marginTop={1} marginRight={1}>
        Campos
      </Typography>

      <Table
        toolbar={false}
        data={formik.values.fields}
        columns={[
          { title: "Pergunta", field: "label" },
          {
            title: "Entrada de dado",
            field: "inputType.value",
            lookup: lookupInputType,
          },
          {
            title: "Identificador de entrada",
            field: "key.value",
            lookup: lookupKey,
          },
          {
            title: "Ativo",
            align: "center",
            field: "active",
            render: ({ active }) => (
              <Switch
                disableRipple
                checked={Boolean(active)}
                readOnly
                inputProps={{ "aria-label": "controlled" }}
              />
            ),
          },
          {
            title: "Obrigatório",
            align: "center",
            field: "required",
            render: ({ required }) => (
              <Switch
                disableTouchRipple
                disableRipple
                checked={Boolean(required)}
                readOnly
                inputProps={{ "aria-label": "controlled" }}
              />
            ),
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          pageSize: 5,
          selectionProps: () => ({ color: "primary" }),
        }}
      />
    </>
  );
}
